import React, { useEffect, useState } from "react";

import { useGetFormattedEmployeeDataQuery } from "EmployerApplication/api";
import { requestPricing } from "EmployerApplication/Components/ComprehensiveCostEstimation/EmployeeDetailsBody";
import { useSelector } from "react-redux";

import { EmployeesSection } from "./EmployeeDetailsBody";

export const StaticEmployeeDetailsBody = ({
  employeeProfile,
  contributionType,
  applicationContribution,
  medicalPlans,
  initialVisionPlan,
  initialDentalPlan,
}) => {
  const { data } = useGetFormattedEmployeeDataQuery();
  const formattedEmployeeData = data?.formatted_employee_data;
  const companyIDToken = useSelector((state) => state.companyProfile.idToken);
  const employees = formattedEmployeeData.length > 0 ? formattedEmployeeData : employeeProfile;

  const [plans, setPlans] = useState(JSON.parse(JSON.stringify(medicalPlans)) || null);

  const [dentalPlan, setDentalPlans] = useState(initialDentalPlan ? JSON.parse(JSON.stringify(initialDentalPlan)) : null);

  const [visionPlan, setVisionPlans] = useState(initialVisionPlan ? JSON.parse(JSON.stringify(initialVisionPlan)) : null);

  const [eesForQuote] = useState(JSON.parse(JSON.stringify(employees || [])) || null);

  const [contributions] = useState(JSON.parse(JSON.stringify(applicationContribution)));

  useEffect(() => {
    requestPricing(eesForQuote, plans, dentalPlan, visionPlan, companyIDToken, setPlans, setDentalPlans, setVisionPlans);
  }, [eesForQuote]);

  return (
    <EmployeesSection
      employees={eesForQuote}
      plans={plans}
      contributionType={contributionType}
      contributions={contributions}
      selectedVisionPlan={visionPlan}
      selectedDentalPlan={dentalPlan}
    />
  );
};

export default StaticEmployeeDetailsBody;
